import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header/Header'
import Home from './components/Home/Home';

function App() {
  return (
    <div className="">
      <Header></Header>
      <Home></Home>
    </div>
  );
}

export default App;
